import { render, staticRenderFns } from "./PatientGroupTab.vue?vue&type=template&id=7bfc1534&scoped=true"
import script from "./PatientGroupTab.vue?vue&type=script&lang=js"
export * from "./PatientGroupTab.vue?vue&type=script&lang=js"
import style0 from "./PatientGroupTab.vue?vue&type=style&index=0&id=7bfc1534&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bfc1534",
  null
  
)

export default component.exports